import { render, staticRenderFns } from "./answerAll.vue?vue&type=template&id=e45cdb46&scoped=true"
import script from "./answerAll.vue?vue&type=script&lang=js"
export * from "./answerAll.vue?vue&type=script&lang=js"
import style0 from "./answerAll.vue?vue&type=style&index=0&id=e45cdb46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45cdb46",
  null
  
)

export default component.exports